import { Box, Typography, Paper, Grid, Autocomplete, TextField, CircularProgress, Button, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import React, { useEffect, useState } from "react";
import GapsTopProd from "./GapsTopProducts";
import TopSkus from "./TopSkus";
import { getUrl } from "src/Utils/Common";
import { useSelector } from "react-redux";
import DonutChart from "../StatisticsTest/components/DonutChartPinned";
import ReactMarkdown from 'react-markdown'
import { data } from "../Dashboard/data";
import HtmlRenderer from "src/Components/shared/shared/HtmlRenderer";
import FacebookCircularProgress from "src/Components/shared/shared/Loading";
import DiagnosticsTour from "src/Components/TourGuide/DiagnosticsTour";

function GapsAndOppotunity() {
  const projectId = useSelector((state) => state.userProject.projectId);

  const[brand, setBrand] = useState("")
  const[sku, setSku] = useState("")
  const[options, setOptions] = useState([])
  const[loading, setLoading] = useState(false)
  const[storesData, setStoresData] = useState({})
  const[selectedStore, setSelectedStore] = useState("")
  const[valueShare, setValueShare] = useState([]);
  const[volumeSales, setVolumeSales] = useState([]);
  const[exportingData, setExportingData] = useState(false);
  const[donutChatOptions, setDonutChatOptions] = useState({});
  const[donutChatOptions2, setDonutChatOptions2] = useState({});
  const[summarizedInsights, setSummarizedInsights] = useState("");
  const[fullInsights, setFullInsights] = useState("");
  const[hierarchy, setHierarchy] = useState("brand");
  const isFreeTrialUser = localStorage.getItem("role") === "free_trial";


  const handleUpdateInsights = (summary, full) =>{

  }
  const handleSelection = (event, value) => {
    setSelectedStore(value)
    console.log('Selected value:', value);
    console.log(storesData[value])
    console.log(storesData["Total Market"])
    setValueShare([{name:"valueSahre", data:[storesData["Total Market"]["Value Share 2023"]-storesData[value]["Value Share 2023"], storesData[value]["Value Share 2023"]]}])
    setVolumeSales([{name:"volumeSales", data:[
      (storesData["Total Market"]["Volume Sales 2023"]-storesData[value]["Volume Sales 2023"])/storesData["Total Market"]["Volume Sales 2023"]*100,
      (storesData[value]["Volume Sales 2023"]/storesData["Total Market"]["Volume Sales 2023"]*100)
    ]}])
    // You can trigger your action here

    setDonutChatOptions({
      chart: {
        type: "donut",
      },
      colors: ["#08306B", "#21A0FF"],
      labels:[sku, value],
      title: {
        text: "Value Share 2023",
        align: "center",
        style: {
          fontSize: "14px",
          fontWeight: "bold",
        },
      },
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
        fontSize:"10px",
        formatter: (val) => `${val.toFixed(1)}%`,
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}`,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    })
    setDonutChatOptions2({
      chart: {
        type: "donut",
      },
      colors: ["#08306B", "#21A0FF"],
      labels:[sku, value],
      title: {
        text: "Volume Sales 2023",
        align: "center",
        style: {
          fontSize: "14px",
          fontWeight: "bold",
        },
      },
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
        fontSize:"10px",
        formatter: (val) => `${val.toFixed(1)}%`,
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}`,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    })
  };

  const handleExportData = async () => {
    try {
      setExportingData(true)
      // Make the API call to fetch the file (use your actual API endpoint)
      const token = localStorage.getItem("userId") || "";
      const response = await fetch(`${getUrl()}/market_overview/gaps_and_opp_all_data?project_id=${projectId}&hierarchy=brand`, {
        method: 'GET', // or 'POST' depending on your API
        headers: {
          'Content-Type': 'application/json',
          "x-access-token": token,
          "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
        },
      });
  
      if (response.ok) {
        // Assuming the response contains a file (Blob)
        const blob = await response.blob();
  
        // Create a download link for the blob
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = 'exported-data.csv'; // Set the filename for the download
        link.click(); // Programmatically click to trigger the download
  
        // Clean up the URL object after the download
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Failed to export data');
      }
    } catch (error) {
      console.error('Error exporting data:', error);
    }
    finally{
      setExportingData(false)
    }
  };

  const handleClick = (brand) => {
    setBrand(brand)
    console.log(brand);
  };

  const handleClickSku = (sku) =>{
    setSelectedStore("")
    setValueShare([])
    setSku(sku)
    console.log(sku)
    async function fetchTopProducts() {
      if (!projectId) {
        console.warn("Project ID is missing.");
        return;
      }
      setLoading(true);

      try {
        const url = `${getUrl()}/market_overview/top_products`;
        const token = localStorage.getItem("userId") || "";
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": token,
          "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
        };
        const payload = {
          project_id: projectId,
          hierarchy: "store_name",
          opps_filter: true,
          filters: { sku_db: sku },
          top_5: false,
          time_period: "P12M",
          target: 0,
          token,
        };

        const response = await fetch(url, {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        const stores_data = {};

        const names = result.Name;

        for (let i = 0; i < names.length; i++) {
          const name = names[i];
          stores_data[name] = {};

          for (const key in result) {
            if (key !== "Name") {
              stores_data[name][key] = result[key][i];
            }
          }
        }
        setStoresData(stores_data)
        console.log(stores_data);

        if (!result || Object.keys(result).length === 0) {
          throw new Error("Invalid API response structure.");
        }

        // Transform API response into a usable format
        
        const stores = result.Name.filter(item => item !== "Total Market");
        setOptions(stores);
      } catch (error) {
        console.error("Error fetching top products:", error);
      } finally {
        setLoading(false)
      }
    }

    fetchTopProducts();
  }

  const handleHierSelect = (event) =>{
    const raw = event.target.value;
    if (isFreeTrialUser && raw === "Class") {
      setHierarchy("segment");
      return;
    }
    setHierarchy(raw);
  }

  useEffect(() => {
    const handleTourReset = () => {
      setBrand("");
      setSku("");
      setSelectedStore("");
      setValueShare([]);
      setVolumeSales([]);
      setOptions([]);
      setStoresData({});
      setDonutChatOptions({});
      setDonutChatOptions2({});
    };
    window.addEventListener("tour:resetDiagnostics", handleTourReset);
    return () => window.removeEventListener("tour:resetDiagnostics", handleTourReset);
  }, []);

  useEffect(() => {
      
    }, [projectId]);


  return (
    <Box>
      <DiagnosticsTour />
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', margin: '15px' }}>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />
                <span style={{ padding: '0 10px', color: '#999' }}> Market Overview</span>
                <span data-tour="diag-hierarchy">
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="demo-select-small-label">Hierarchy</InputLabel>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={hierarchy}
                      label="Hierarchy"
                      onChange={handleHierSelect}
                    >
                      <MenuItem value={"brand"}>Brand</MenuItem>
                      <MenuItem value={isFreeTrialUser ? "segment" : "Class"}>class</MenuItem>
                    </Select>
                  </FormControl>
                </span>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />
            </div>
            <Grid item xs={12} md={12}>
              <div data-tour="diag-table">
                <GapsTopProd hierarchy={hierarchy} updateBrand={handleClickSku} setSku={setSku} setValue={setValueShare} setSummarizedInsights={setSummarizedInsights} setFullInsights={setFullInsights}/>
              </div>
          </Grid>
          <div data-tour="diag-insights">
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', margin: '15px' }}>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />
                <span style={{ padding: '0 10px', color: '#999' }}>{sku} Store GAPs</span>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #ccc' }} />
            </div>
            {sku === "" && (
              summarizedInsights && fullInsights ? (
                <HtmlRenderer htmlString={summarizedInsights} modalContent={fullInsights} />
              ) : (
                <FacebookCircularProgress />
              )
            )}
          </div>
            {sku !== "" && (
                <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                marginBottom: '16px' 
              }}>
              <Autocomplete
                options={options}
                onChange={handleSelection}
                style={{ width: 400 }} // <-- Set width here
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choose a store"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              <span data-tour="diag-export">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleExportData}
                  disabled={exportingData}
                  sx={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  {exportingData ? (
                    <CircularProgress size={24} sx={{ color: 'white' }} />
                  ) : (
                    'Export All Stores Data'
                  )}
                </Button>
              </span>
              </div>
            )}
            
              {
                valueShare.length !== 0?
                <Grid>
                <div style={{ marginBottom: '16px' }}>
                <Paper
                    sx={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      padding: 0, // Remove padding
                      borderColor: "red"
                    }}
                    className="user-card"
                    elevation={3}
                  >
                    <div
                      style={{
                        flex: 1, // Allow the component to take all available space
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                          >
                            <DonutChart title={"Value Share 2023"} dataValues={valueShare} labels={[{labels:["Total Market", selectedStore]}]} chartOptions={donutChatOptions} />
                            <DonutChart title={"Volume Sales 2023"} dataValues={volumeSales} labels={[{labels:["Total Market", selectedStore]}]} chartOptions={donutChatOptions2}/>
                          </div>
                          </div>
                          </Paper>
                          </div>
                          </Grid>
                          :
                          <></>
                  } 
            
    </Box>
  );
}

export default GapsAndOppotunity;
